import { Component, OnInit, OnDestroy } from "@angular/core";
import { LocalstorageService } from "../services/localstorage.service";
import { Router, NavigationEnd } from "@angular/router";
import { environment } from "../../environments/environment";
import { Subscription } from "rxjs";

@Component({
  selector: "app-nav-menu",
  templateUrl: "./nav-menu.component.html",
  styleUrls: ["./nav-menu.component.css"],
})
export class NavMenuComponent implements OnInit, OnDestroy {
  isExpanded = false;
  isVerified = false;
  hideHeader = false;

  env: string | undefined;

  private verifiedSub: Subscription;
  private routerEventsSub: Subscription;

  constructor(
    private localstorageService: LocalstorageService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.env = environment.headerBanner;

    this.verifiedSub = this.localstorageService.verifiedSubject.subscribe(
      (stateData) => {
        this.isVerified = stateData;
      }
    );

    // hide header when route is spark-moment-survey
    this.hideHeader =
      !!this.router.url && this.router.url.startsWith("/spark-moment-survey");

    this.routerEventsSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.hideHeader =
          !!event.urlAfterRedirects &&
          event.urlAfterRedirects.startsWith("/spark-moment-survey");
      }
    });
  }

  ngOnDestroy(): void {
    if (this.verifiedSub) {
      this.verifiedSub.unsubscribe();
    }
    if (this.routerEventsSub) {
      this.routerEventsSub.unsubscribe();
    }
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  onLogout() {
    this.router.navigate(["/logout"]);
  }

  onVolunteer() {
    this.router.navigate(["/volunteer"]);
  }
}
